import { useAgentEditorStore } from '@/state/root';
import { runInAction } from 'mobx';

export const useClearRecoilState = () => {
    const agentEditorStore = useAgentEditorStore();

    return () => {
        runInAction(() => {
            agentEditorStore.resetTtsSelectedVoice();
            agentEditorStore.resetTtsSelectedLanguage();
            agentEditorStore.resetSelectedPresenter();
            agentEditorStore.resetPresenterIsStitch();
            agentEditorStore.resetPresenterBackgroundSourceUrl();
            agentEditorStore.resetPresenterBackgroundThumbnailUrl();
        });
    };
};
